module.exports = __webpack_public_path__ + "assets/profitwell.af446c7a.svg";